import type { ColDef } from 'ag-grid-community';

export const relativeSortColumnsWithHide = (
  source: ColDef[],
  target: (string | boolean)[][],
): ColDef[] => {
  const order = Object.fromEntries(
    target.map((v, i) => [v[0], { order: i, hide: v[1] }]),
  );

  return Array.from(source)
    .map((x) => ({ ...x, hide: order[x.field!]?.hide ?? false }))
    .sort(
      (a, b) =>
        (order[a.field!]?.order ?? Number.MAX_VALUE) -
        (order[b.field!]?.order ?? Number.MAX_VALUE),
    );
};
